export default __webpack_public_path__ + "static/media/Congo.8d6b4480.png";